import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { useStore } from "@/context/StoreContext";
import { waLink } from "@/lib/api";

export function WhatsAppFloat() {
  const { t } = useLang();
  const { settings } = useStore();
  if (!settings?.whatsapp_number) return null;
  return (
    <motion.a
      data-testid="whatsapp-float-btn"
      href={waLink(settings.whatsapp_number, t("wa_contact_msg"))}
      target="_blank"
      rel="noreferrer"
      aria-label={t("contact_wa")}
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2.4, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="group fixed bottom-5 end-5 z-30 flex h-14 items-center gap-3 rounded-full border border-[#C6A76A]/50 bg-[#0B0B0C]/90 pe-4 ps-4 text-[#F7F3EB] shadow-[0_10px_40px_-10px_rgba(198,167,106,0.45)] backdrop-blur-md transition-colors duration-500 hover:bg-[#C6A76A] hover:text-[#0B0B0C] sm:bottom-8 sm:end-8"
    >
      <span className="absolute inset-0 -z-10 animate-ping rounded-full border border-[#C6A76A]/30 [animation-duration:3s]" />
      <MessageCircle className="h-5 w-5 text-[#C6A76A] transition-colors duration-500 group-hover:text-[#0B0B0C]" strokeWidth={1.4} />
      <span className="hidden text-xs tracking-[0.18em] sm:inline rtl:text-sm rtl:tracking-normal">{t("whatsapp_label")}</span>
    </motion.a>
  );
}
